module.exports = __webpack_public_path__ + "static/img/wdtx1-4.9349161.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdtx1-4.png
// module id = 899
// module chunks = 0